import React from 'react';

class ProductCompareButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
    };

    this.addCompareProduct = this.addCompareProduct.bind(this);
    this.removeCompareProduct = this.removeCompareProduct.bind(this);
  }

  componentDidMount() {
    this.getCompareProducts();
    PubSub.subscribe('PRODUCT-COMPARE-UPDATED', (msg, products) => {
      this.setState({
        products,
      });
    });
  }

  addCompareProduct(product) {
    $.ajax({
      url: '/products_compare',
      data: {
        product_id: product,
      },
      method: 'POST',
      dataType: 'JSON',
      success: products => {
        PubSub.publish('PRODUCT-COMPARE-ADDED', products);
        this.getCompareProducts();
      },
    });
  }

  removeCompareProduct(product) {
    $.ajax({
      url: '/products_compare',
      data: {
        product_id: product,
      },
      method: 'DELETE',
      dataType: 'JSON',
      success: products => {
        PubSub.publish('PRODUCT-COMPARE-ADDED', products);
        this.getCompareProducts();
      },
    });
  }

  getCompareProducts() {
    $.ajax({
      url: '/products_compare',
      method: 'GET',
      dataType: 'JSON',
      success: products => {
        this.setState(
          {
            products,
          },
          () => PubSub.publish('PRODUCT-COMPARE-UPDATED', products),
        );
      },
    });
  }

  render() {
    const { productId, compareIcon, compareAdded, compareFull } = this.props;
    const { products } = this.state;
    const maxComparedProducts = 3;
    if (products.length === maxComparedProducts) {
      return (
        <button
          className="product--compare hidden-phone"
          aria-label="Compare is full"
          onClick={() => {
            this.removeCompareProduct(productId);
          }}>
          <img alt="" src={compareFull} />
          <span className="compare--full">Compare Full</span>
        </button>
      );
    }

    return products.some(({ id }) => id === productId) ? (
      <button
        className="product--compare hidden-phone"
        type="button"
        aria-label="Remove product from Compare"
        onClick={() => {
          this.removeCompareProduct(productId);
        }}>
        <img alt="" src={compareAdded} height={17} width={20} />
        <span>Remove</span>
      </button>
    ) : (
      <button
        className={`product--compare hidden-phone ${
          products.length === maxComparedProducts ? 'inactive' : ''
        }`}
        type="button"
        aria-label="Add product to Compare"
        onClick={() => {
          this.addCompareProduct(productId);
        }}>
        <img alt="" src={compareIcon} height={18} width={20} />
        <span>Compare</span>
      </button>
    );
  }
}

export default ProductCompareButton;
